export const COLORS = {
  primary: '#202A44',
  secondary: '#CB333B',
  tertiary: '#001871',
  gray: '#EBEBEC',
  darkGray: '#808080',
  white: '#FFFFFF',
  background: '#EBEBEC',
  backgroundDark: '#D3D3D3',
  black: '#000000',
  lightBlack: '#333333',
  lightGreen: '#d2f8d2',
  dev: '#40E0D0',
  uat: '#A13736'
}
